import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { Button, ListGroupItemProps, ListGroupItem, OverlayTrigger, Tooltip } from "react-bootstrap";
import { GamePlayedItemUser, UserGamePlayedItem } from "../models/PlayData";

dayjs.extend(relativeTime);

export interface SocialPlayedGameListItemProps extends ListGroupItemProps {
    gamePlayed: UserGamePlayedItem;
    currentUserId: string;
    onAddPlay: () => void;
    onClick: () => void;
}

export const SocialPlayedGameListItem = ({ gamePlayed, currentUserId, onAddPlay, onClick, ...props }: SocialPlayedGameListItemProps): React.ReactElement => {
    const UserIcon = ({ user }: { user: GamePlayedItemUser }) => (
        <OverlayTrigger overlay={<Tooltip id={user.userId}>{user.userName || 'Unknown'}</Tooltip>}>
            <span>{user.userIcon}</span>
        </OverlayTrigger>
    );
    const users = gamePlayed?.users?.map((user) => <span key={user.userId} style={{ float: 'right' }}><UserIcon user={user} /></span>)
    const shouldShowAddButton = !gamePlayed.users.some((user) => user.userId === currentUserId);
    const AddMeButton = () => (
        <>
            {shouldShowAddButton && <OverlayTrigger overlay={<Tooltip id={'add'}>Join play</Tooltip>}><span key={'add'} style={{ float: 'right', marginLeft: '.25rem' }}><strong><a style={{ textDecoration: 'none' }} href="#" onClick={(event) => {
                event.stopPropagation();
                onAddPlay();
            }} aria-label={`Add ${gamePlayed.name} to your plays`}>
                +
            </a></strong></span></OverlayTrigger>}
        </>
    )

    return (
        <ListGroupItem {...props} onClick={onClick}>
            <div>
                <div><strong>{gamePlayed.name}</strong></div>
                <div><em>{dayjs(gamePlayed.playedOn).fromNow()}</em><AddMeButton />{users}</div>
            </div>
        </ListGroupItem>
    )
}
